<nk-card [attr.data-cy]="'company-flags-card'">
  <nk-card-header>
    @if (!printVersion() && showYearSelector()) {
      <div class="btn-group float-end" dropdown>
        <button
          dropdownToggle
          type="button"
          class="btn btn-sm btn-info dropdown-toggle normal-case weight-bold"
          aria-controls="dropdown-basic">
          {{ currentFrequency.label }}<span class="caret"></span>
        </button>
        <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
          @for (frequency of frequencyList; track frequency.key) {
            <li role="menuitem">
              <button
                class="dropdown-item"
                (click)="changeFrequency(frequency)"
                [class.active]="frequency.key === currentFrequency.key">
                {{ frequency.label }}
              </button>
            </li>
          }
        </ul>
      </div>
    }

    <h6 class="card-heading" style="line-height: 1">
      <i class="fa fa-flag-o"></i>
      {{ titleOverride() ? titleOverride() : ('company_page.company_flags_card.header' | translate) }}
    </h6>
  </nk-card-header>
  <nk-card-content type="table">
    @if (currentFrequency.key === 'default' && companyFlagCompositeList().length && !printVersion() && showDetails()) {
      <div class="text-muted">
        <em>{{ 'company_page.company_flags_card.header' | translate }}</em
        >: {{ 'company_page.company_flags_card.time_horizon' | translate }} <br />
        <span>
          {{ 'company_page.company_flags_card.see' | translate }}
          <a [routerLink]="['/company/flags']">{{ 'company_page.company_flags_card.flag_index' | translate }} </a>
          {{ 'company_page.company_flags_card.to_lookup_each_flags_default_time_horizon' | translate }}
        </span>
      </div>
    }
    @if (loading()) {
      <nk-spinner></nk-spinner>
    }
    @if (!loading() && companyFlagCompositeList().length === 0) {
      <div>{{ 'company_page.company_flags_card.no_active_flags_for_period' | translate }}</div>
    }
    @if (simpleLayout()) {
      @for (companyFlagComposite of companyFlagCompositeList(); track companyFlagComposite.company_flag.uuid) {
        <div class="row mb-3">
          <div class="col-2">
            <nk-company-flag-icon
              class="d-inline-block me-2"
              size="sm"
              [companyFlagCategoryKey]="companyFlagComposite.company_flag_type.company_flag_category_key"
              [companyFlagTypeAppIconUuid]="
                companyFlagComposite.company_flag_type.app_icon_uuid
              "></nk-company-flag-icon>
          </div>
          <div class="col-9">
            <strong
              >{{ companyFlagComposite.company_flag.flag_date | date }}
              @if (companyFlagComposite.company_flag | flagEndDate; as endDate) {
                <span>- {{ endDate | date }} </span>
              }</strong
            ><br />
            {{ 'company_flag.' + companyFlagComposite.company_flag_type.company_flag_type_key | translate }}
          </div>
        </div>
      }
    }
    @if (!loading() && !simpleLayout()) {
      <table class="table table-sm table-clear table-borderless table-striped" style="table-layout: fixed">
        <thead>
          @if (companyFlagCompositeList().length) {
            <tr class="small text-muted">
              <th [style.width]="printVersion() ? '150px' : '80px'">
                {{ 'company_page.company_flags_card.date' | translate }}
              </th>
              <th>
                {{ 'company_page.company_flags_card.flag_name' | translate }}
              </th>
            </tr>
          }
        </thead>
        <tbody>
          @for (companyFlagComposite of companyFlagCompositeList(); track companyFlagComposite.company_flag.uuid) {
            <tr>
              <td style="vertical-align: top" class="text-muted small">
                <div class="my-1">
                  {{ companyFlagComposite.company_flag.flag_date | date }}
                  @if (companyFlagComposite.company_flag | flagEndDate; as endDate) {
                    <span> - {{ endDate | date }} </span>
                  }
                </div>
              </td>
              <td style="vertical-align: top">
                <div class="d-flex">
                  <div class="my-1">
                    <nk-company-flag-icon
                      class="d-inline-block me-2"
                      size="sm"
                      [companyFlagCategoryKey]="companyFlagComposite.company_flag_type.company_flag_category_key"
                      [companyFlagTypeAppIconUuid]="
                        companyFlagComposite.company_flag_type.app_icon_uuid
                      "></nk-company-flag-icon>
                  </div>
                  <div>
                    <nk-company-flag-context-popover [companyFlagComposite]="companyFlagComposite"></nk-company-flag-context-popover>
                    @if (
                      companyFlagComposite.company_flag_type.default_flag_end_days ||
                      companyFlagComposite.company_flag_type.default_lookback_days
                    ) {
                      <div class="small text-muted">
                        @if (companyFlagComposite.company_flag_type.default_flag_end_days; as default_flag_end_days) {
                          {{
                            'company_page.company_flags_card.default_flag_end_days'
                              | translate: { default_flag_end_days: default_flag_end_days }
                          }}
                        } @else if (
                          currentFrequency.key === 'default' &&
                          companyFlagComposite.company_flag_type.default_lookback_days
                        ) {
                          <span class="text-muted">
                            {{ 'company_page.company_flags_card.within_last' | translate }}
                            {{ companyFlagComposite.company_flag_type.default_lookback_days }}
                            {{ 'company_page.company_flags_card.days' | translate }}
                          </span>
                        }
                        @if (
                          currentFrequency.key === 'default' &&
                          companyFlagComposite.company_flag_type.default_lookback_days === null
                        ) {
                          <span class="text-muted"
                            >({{ 'company_page.company_flags_card.within__any_time' | translate }})</span
                          >
                        }
                        @if (
                          currentFrequency.key === 'default' &&
                          companyFlagComposite.company_flag_type.default_lookback_days === 0
                        ) {
                          <span class="text-muted">({{ 'company_page.company_flags_card.today' | translate }})</span>
                        }
                      </div>
                    }
                  </div>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }

    @if (companyFlagCompositeList().length) {
      <p class="small text-right pb-0 mb-0 mt-2">
        {{ 'company_page.company_flags_card.only_latest_of_each_type_of_flag_is_shown' | translate }}
      </p>
    }
    @if (!printVersion()) {
      <p class="small text-right pb-0 mb-0">
        <a [routerLink]="['/company/flags']">{{
          'company_page.company_flags_card.view_index_of_all_possible_flags' | translate
        }}</a>
      </p>
    }
  </nk-card-content>
</nk-card>
